import { lazy } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const BudgetsPage = lazy(() => import('./pages/BudgetsPage'));
const ActualCostsPage = lazy(() => import('./pages/ActualCostsPage'));
const BudgetVsActualPage = lazy(() => import('./pages/BudgetVsActualPage'));
const ProfitabilityPage = lazy(() => import('./pages/ProfitabilityPage'));
const BillingRulesPage = lazy(() => import('./pages/BillingRulesPage'));
const ProjectInvoicingPage = lazy(() => import('./pages/ProjectInvoicingPage'));
const CostAllocationPage = lazy(() => import('./pages/CostAllocationPage'));

export const AccountingRoutes: RouteObject = {
  path: 'accounting',
  handle: { crumb: 'Project Accounting & PSA' },
  element: <ModuleGuard moduleId="projects.accounting" />,
  children: [
    { index: true, element: <Navigate to="budgets" replace /> },
    { path: 'budgets', element: <BudgetsPage />, handle: { crumb: 'Budgets' } },
    { path: 'actual-costs', element: <ActualCostsPage />, handle: { crumb: 'Actual Costs' } },
    { path: 'budget-vs-actual', element: <BudgetVsActualPage />, handle: { crumb: 'Budget Vs Actual' } },
    { path: 'profitability', element: <ProfitabilityPage />, handle: { crumb: 'Profitability' } },
    { path: 'billing-rules', element: <BillingRulesPage />, handle: { crumb: 'Billing Rules' } },
    { path: 'project-invoicing', element: <ProjectInvoicingPage />, handle: { crumb: 'Project Invoicing' } },
    { path: 'cost-allocation', element: <CostAllocationPage />, handle: { crumb: 'Cost Allocation' } },
  ],
};
